import createCache from "@emotion/cache";
import { prefixer } from "stylis";
import rtlPlugin from "@mui/stylis-plugin-rtl";

// Emotion cache that flips emitted CSS (margins, positioning, transforms) for RTL.
// `prepend: true` mirrors the `StyledEngineProvider injectFirst` ordering the LTR path
// uses, so MUI styles keep landing before app overrides. Module-level singleton so
// toggling direction never re-injects styles.
export const rtlCache = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
  prepend: true,
});
